import React, { useState } from "react";
import { Button } from "@curves/ui-base";
import InBodyStartScanDialogs from "@icoach/inbody/dialog/InBodyStartScanDialogs";
import { MEASURE_REFERENCE_TYPE } from "@icoach/constants/";

const InBodyVisitorsDialog = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(false);

	const handleOnClick = () => {
		setOpenDialog(true);
	};

	return (
		<React.Fragment>
			<Button onClick={handleOnClick} variant="outlined" color="secondary">
				訪客量身
			</Button>
			<InBodyStartScanDialogs
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				sourceData={{
					referenceType: MEASURE_REFERENCE_TYPE.GUEST,
					peopleID: 0,
				}}
			/>
		</React.Fragment>
	);
});

export default InBodyVisitorsDialog;
